module.exports = __webpack_public_path__ + "static/media/vibrant-2.5f84cd51.png";